/* ----- COMPONENT TEST DATA ---- 
    1. Make sure to change "template" to your actual component name
*/
import { template as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: "Let's talk.",
  bodyText: "Share a few details, and we'll be in touch",
  disclaimer: 'Testing a disclaimer',
  img: '/assets/contactformBG2.png',
  ctaText: 'Send Message',
  ctaUrl: '#',
  reverse: false,
};

export default fakeProps(schema, TestData);
